import { useEffect, useState } from 'react';
import { Button, LegalDialog, ResponsiveDialog } from '../components/ui';
import { useT } from '../i18n';
import styles from './Attribution.module.css';

export function AttributionDialog({ platform, busy, error, onAnswer }: {
  platform: 'ios' | 'android'; busy: boolean; error: boolean;
  onAnswer: (choice: 'allow' | 'deny') => void;
}) {
  const { t } = useT();
  const [privacy, setPrivacy] = useState(false);
  useEffect(() => {
    if (!privacy) return;
    // L1 liefert den Abschnitt parallel. Kein Rechtstext wird hier verändert.
    const scroll = () => {
      const target = document.querySelector<HTMLElement>('[data-i18n="legal.privacy.full.s2a.attribution.heading"]');
      if (!target) return false;
      target.closest('[role="dialog"]')?.querySelector<HTMLButtonElement>('.legal-version-btn[data-version="full"][aria-pressed="false"]')?.click();
      target.scrollIntoView?.({ block: 'start' });
      return true;
    };
    const observer = new MutationObserver(() => { if (scroll()) observer.disconnect(); });
    if (!scroll()) observer.observe(document.body, { childList: true, subtree: true });
    return () => observer.disconnect();
  }, [privacy]);
  return <>
    <ResponsiveDialog open={!privacy} title={t('attribution.title')} onClose={() => { if (!busy) onAnswer('deny'); }} initialFocus="none">
      <p>{t(`attribution.body.${platform}`)}</p>
      <button type="button" className={styles.link} onClick={() => setPrivacy(true)}>{t('attribution.privacy')}</button>
      {error && <p role="alert">{t('attribution.failed')}</p>}
      <div className={styles.actions}>
        <Button variant="secondary" disabled={busy} onClick={() => onAnswer('allow')}>{t('attribution.allow')}</Button>
        <Button variant="secondary" disabled={busy} onClick={() => onAnswer('deny')}>{t('attribution.deny')}</Button>
      </div>
    </ResponsiveDialog>
    <LegalDialog doc={privacy ? 'datenschutz' : null} onClose={() => setPrivacy(false)} />
  </>;
}
